import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import toast from "react-hot-toast";
import { Page } from "types/dto/Page";
import { RegistroTabelaProcessoJudicialDTO } from "types/dto/RegistroTabelaProcessoJudicialDTO";
import { RequestBuscarProcessoJudicial } from "types/dto/RequestBuscarProcessoJudicial";

export const useGetProcessosJudiciaisPaginados = (request: RequestBuscarProcessoJudicial) => {
  const onError = () => {
    toast.error("Erro ao buscar os processos judiciais");
  };

  const config = {
    staleTime: 1000 * 60 * 5,
    retry: 5,
  };

  return useFetch<Page<RegistroTabelaProcessoJudicialDTO>>({
    key: ["processos-judiciais", request],
    url: api.processosJudiciais.getProcessosJudiciaisPaginados,
    params: request,
    onError,
    config,
  });
};
